
import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';

export class UtilizationSearchModel extends SearchBaseModel {
  public GarageId: number;
  public GarageName: string;
  public IsCarActive: boolean;
  public IsUtilisationOrder: boolean;
  public CustomerId: number;
  public CustomerName: string;
  public RegistrationNumber: string;
  public DateRange: DateRange;
  public Period: any;
  public ArticleName: string;
  public ArticleId: number;
  public SeasonId: number;
  public Count: number;
  public TryeStateValueId: number;
  public TyreState: any;
  public CarId: number;

  constructor() {
    super();
    this.GarageId = null;
    this.GarageName = null;
    this.IsCarActive = null;
    this.IsUtilisationOrder = null;
    this.CustomerId = null;
    this.CustomerName = null;
    this.RegistrationNumber = null;
    this.DateRange = new DateRange();
    this.ArticleName = null;
    this.ArticleId = null;
    this.SeasonId = null;
    this.Count = null;
    this.TryeStateValueId = null;
    this.Period = null;
  }

}
